<script>
  import { _ as t, locale } from "svelte-i18n";
</script>

<style>
  .wrapper {
    background-color: #f6f6f6;
    padding-bottom: 45px;
  }

  .content {
    max-width: 900px;
    margin: 0 auto;
  }

  h4 {
    font-size: 16px;
    margin: 24px 0 10px;
  }

  .logo {
    margin: 0 20px;
    padding: 30px;
    display: flex;
    justify-content: center;

    background-image: linear-gradient(
      to right,
      black 33%,
      rgba(255, 255, 255, 0) 0%
    );
    background-position: bottom;
    background-size: 5px 1px;
    background-repeat: repeat-x;
  }

  #logo-desktop {
    display: none;
  }
  #logo-mobile {
    display: block;
  }
  .impressum {
    padding: 0 20px;
    font-size: 13px;
    font-weight: 200;
  }

  @media only screen and (min-width: 600px) {
    #logo-mobile {
      display: none;
    }
    #logo-desktop {
      display: block;
    }

    .wrapper {
      margin-top: 70px;
    }
    .content {
      display: flex;
      padding: 70px 0;
    }
    .logo {
      margin: 0 20px;
      padding: 30px;
      display: flex;
      justify-content: flex-end;
      flex: 1;

      /*Vertical*/
      background-image: linear-gradient(black 33%, rgba(255, 255, 255, 0) 0%);
      background-position: right;
      background-size: 1px 3px;
      background-repeat: repeat-y;
    }

    .impressum {
      flex: 1;
      font-size: 15px;
    }

    h4 {
      font-size: 18px;
    }
  }

  p {
    margin: 0;
  }
</style>

<div class="wrapper">
  <div class="content">
    <div class="logo">
      <img
        id="logo-mobile"
        src="/images/ILK_Logo.png"
        width="65px"
        height="65px"
        alt="logo" />
      <img
        id="logo-desktop"
        src="/images/ILK_Logo-Desktop.png"
        width="117px"
        height="117px"
        alt="logo" />
    </div>
    <div class="impressum">
      <h4>{$t('footer.contact')}</h4>
      <p>
        {$t('footer.address1')}
        <br />
        {$t('footer.address2')}
        <br />
        {$t('footer.address3')}
        <br />
        {$t('footer.address4')}
        <br />
        <a href="mailto:kontakt@parlamente.ch">kontakt@parlamente.ch</a>
      </p>
    </div>
  </div>
</div>
